import { Flex, Heading, Box, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

// A simple, extensible list of settings entries. Add more items here as
// the Settings page grows - each just needs a label and a path.
const settingsItems = [
  {
    id: "game-history",
    label: "Game History",
    path: "/settings/history",
  },
];

const Settings = () => {
  const navigate = useNavigate();

  return (
    <Flex direction="column" align="center" gap="20px" p={{ base: 4, md: 8 }}>
      <Heading as="h2" size="lg" color="headline.400" fontStyle="italic">
        Settings
      </Heading>
      <Flex direction="column" w="100%" maxW="500px" gap={3}>
        {settingsItems.map((item) => (
          <Box
            key={item.id}
            as="button"
            type="button"
            onClick={() => navigate(item.path)}
            textAlign="left"
            w="100%"
            p={4}
            border="1px solid #63aab5"
            borderRadius="8px"
            bg="white"
            _hover={{ bg: "#f0f7f8" }}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Text fontWeight="bold" color="headline.400">
              {item.label}
            </Text>
            <Text color="gray.400" fontSize="lg">
              &rsaquo;
            </Text>
          </Box>
        ))}
      </Flex>
    </Flex>
  );
};
export default Settings;
